import { Component } from '@angular/core';
import { MaterialPage } from '../../../../components/page/material-page.component';
import { Meta, Title } from '@angular/platform-browser';
import { SidenavService } from 'src/app/_services/sidenav.service';
import { BreakpointObserver } from '@angular/cdk/layout';
import { Router } from '@angular/router';

@Component({
  templateUrl: './tac-page.component.html',
  styleUrls: ['./tac-page.component.scss']
})
export class TacPageComponent extends MaterialPage {

  constructor(
    breakpointObserver: BreakpointObserver,
    titleService: Title,
    meta: Meta,
    sidenavService: SidenavService,
    private router: Router,
  ) {
    super(
      breakpointObserver, 
      titleService, 
      meta, 
      sidenavService,
      router,
      $localize `:page title:Green Box Terms & Conditions`,
      $localize `:page description:Green Box Terms & Conditions`,
      true);
  }
  
}